import SendOtp from "@/views/otp/SendOtp";

export default { SendOtp };
